// extracted by mini-css-extract-plugin
export default {"phoneConfig":"PhoneConfig_phoneConfig__JjFk-","ButtonActive":"PhoneConfig_ButtonActive__TbhIK"};